import React from "react";

const NoDataMessage = ({ message }) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            fontSize: "18px",
            color: "#b4b4b4",
        }}>
            {message}
        </div>
    );
};

export default NoDataMessage;
